import { render } from "./make-purchase.vue?vue&type=template&id=793784bb&scoped=true"
import script from "./make-purchase.vue?vue&type=script&lang=js"
export * from "./make-purchase.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./make-purchase.vue?vue&type=style&index=1&id=793784bb&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793784bb"]])

export default __exports__